export default "__VITE_ASSET__43bacc2d__"